import { bl_fi_sales_commission_pricing_model_hdr_RowClass } from '../../dbschema/bl_fi_sales_commission_pricing_model_hdr.model';
import { BaseContainerModel } from '../base-container.model';

export class SalesCommissionPricingModelHdrContainerModel extends BaseContainerModel {
    bl_fi_sale_commission_pricing_model_hdr: bl_fi_sales_commission_pricing_model_hdr_RowClass = new bl_fi_sales_commission_pricing_model_hdr_RowClass();
}
